/* eslint-disable react/destructuring-assignment */
/* eslint-disable semi */
import React from 'react';
import { FormItem, FormItemProps } from './FormItem'
import { IField, getRequiredError, getMaxLengthError } from './FieldValidation';

export interface TextFieldCallback { (value: string): any }

export interface TextFieldProps extends FormItemProps {
    id: string
    disabled?: boolean
    onChange?: TextFieldCallback // this callback is wired to fire when onBlur event occurs; MISNOMER;
    value: string
    maxLength?: number
    required?: boolean
    requiredMessage?: string
    regex?: string
    regexMessage?: string
    block?: boolean
    selectedCountry?: string // for use by RelatedCompanyDetails.tsx / Q.17
    asYouType?: boolean
}

export interface TextFieldState {
    value: string
    errorMessage?: string
}

const defaultProps: Partial<TextFieldProps> = {
  disabled: false,
  onChange: () => { }, // Provide a default no-op function
  maxLength: 255,
  required: false,
  requiredMessage: 'This field is required', // Default required message
  regex: '', // Default regex
  regexMessage: 'Invalid format', // Default regex message
  block: true,
  selectedCountry: '', // Default selected country
  asYouType: false,
};

// export class TextField extends React.Component<TextFieldProps, TextFieldState> implements IField {
export class TextField<T extends TextFieldProps = TextFieldProps> extends React.Component<T, TextFieldState> implements IField {
  input: HTMLInputElement
  static defaultProps = defaultProps;
  constructor(props?: T, context?: any) {
    super(props, context);

    this.state = {
      value: this.props.value || '',
    };
  }

  componentDidUpdate(prevProps: TextFieldProps, prevState: TextFieldState) {
    if (this.state.value == prevState.value && this.state.value != (this.props.value || '')) {
      this.setState({ value: this.props.value || '' }, () => {
        if (this.state.errorMessage) {
          this.validate(() => { });
        }
      })
    }
    else if (this.props.value != prevProps.value) {
      if (this.state.errorMessage) {
        this.validate(() => { });
      }
    }
  }

  onInput(v: string) {
    this.setState({ value: v });
    if (this.props.asYouType) { this.props.onChange(v); }
  }

  onBlurHandler(v: string) {
    this.props.onChange(v);
  }

  render() {
    if (this.props.preview) {
      return (
        <FormItem {...this.props} errorMessage={this.props.errorMessage || this.state.errorMessage}>
          <div className="form-value">{this.state.value ? this.state.value : '--'}</div>
        </FormItem>
      )
    }

    return (
      <FormItem {...this.props} inputId={this.props.id} errorMessage={this.props.errorMessage || this.state.errorMessage}>
        <div>
          <input className={'emdg-text-input ' +
                `${this.props.block === false ? '' : 'emdg-text-input--block'}` +
                `${(this.props.errorMessage || this.state.errorMessage) ? ' emdg-text-input--invalid' : ''}`
                }
              ref={(r) => this.input = r}
              type={this.getFieldType()}
              id={this.props.id}
              value={this.state.value}
              onChange={(e) => this.onInput(e.target.value)}
              onBlur={(e) => this.onBlurHandler((e.target as HTMLInputElement).value)}
              disabled={this.props.disabled}
              maxLength={this.props.maxLength}
              autoComplete="off" 
            />
        </div>
      </FormItem>
    )
  }

  getValue(): string {
    let v = this.props.value;
    if (!v) {
      v = '';
    }
    v.trim();
    return v;
  }

  hasValue(): boolean {
    let v = this.getValue();
    return (v.length > 0);
  }

  getFieldType(): string {
    return 'text';
  }

  focus() {
    if (this.input) this.input.focus();
  }

  getErrorText(): string {
    let val = this.getValue();
    if (this.props.required === true) {
      if (val.length == 0) {
        return getRequiredError(this.props);
      }
    }
    if (this.props.maxLength) {
      if (val.length > this.props.maxLength) {
        return getMaxLengthError(this.props);
      }
    }
    if (this.props.regex && this.props.regex.length > 0) {
      if (val && val.length > 0) {
        let regex = new RegExp(this.props.regex);
        if (!regex.test(val)) {
          let message = this.props.regexMessage;
          if (!message || message.length == 0) {
            message = `Value did not match ${this.props.regex} pattern`;
          }

          return message;
        }
      }
    }
    return null;
  }

  validate(callback: { (res: boolean): any }, focus?: boolean) {
    let errorText = this.getErrorText();
    this.setError(errorText, () => {
      if (this.props.errorMessage || errorText) {
        if (focus === true) {
          this.focus();
        }
      }
      callback && callback((this.props.errorMessage || errorText) ? false : true);
    })
  }

  setError(errorMessage?: string, callback?: { (): any }) {
    this.setState({ errorMessage }, callback);
  }

  // for use by AbnOrAnyField
  getErrorMessage() {
    return this.state.errorMessage;
  }
}
